export function getTheme() {
  return document.documentElement.dataset.bsTheme;
}

export function setTheme(theme) {
  document.documentElement.dataset.bsTheme = theme;
}
